import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatCardModule } from "@angular/material";
import { BrowserModule } from "@angular/platform-browser";
import { CarouselModule } from "ngx-bootstrap";
import { AppRoutingModule } from "../../app-routing.module";
import { ApplicationTypeService } from "../../services/ApplicationTypeService";
import { ImageService } from "../../services/ImageService";
import { TechnologyCategoryService } from "../../services/TechnologyCategoryService";
import { TechnologyService } from "../../services/TechnologyService";
import { BrokerageComponent } from "./brokerage/brokerage";
import { CommunityComponent } from "./community/community";
import { HomeCarouselComponent } from "./home-carousel/home-carousel.component";
import { HomeComponent } from "./home.component";
import { MarketplaceComponent } from "./marketplace/marketplace.component";
import { ShowroomModule } from "./showroom/showroom.module";

@NgModule({
	declarations: [
		BrokerageComponent,
		CommunityComponent,
		HomeComponent,
		HomeCarouselComponent,
		MarketplaceComponent,
	],
	imports: [
		AppRoutingModule,
		BrowserModule,
		CarouselModule.forRoot(),
		HttpClientModule,
		MatCardModule,
		ShowroomModule,
	],
	exports: [
	],
	providers: [
		ApplicationTypeService,
		ImageService,
		TechnologyService,
		TechnologyCategoryService,
	],
} as NgModule)
export class HomeModule implements NgModule { }



// WEBPACK FOOTER //
// ./Frontend/src/app/components/home/home.module.ts